/* Noorns redesign: one copy of each product per cart (walk finding I1, 2026-10-11), on every page (layout/theme.liquid).
   Every Noorns product is a digital report or a single call, so a second copy of the same one is never useful.
   - Knows which variants are in the cart: from the page (data-cart-variants on this script tag), then from cart.js
     after every cart change Horizon announces (CartLinesUpdateEvent) and when a page comes back from the browser's
     history cache.
   - Any add to cart form (report page and its buy bar, concern pages, All reports, the bundle) and the drawer's
     "Worth a look next" button: when that variant is already in the cart, the button reads "In your cart", and
     pressing it opens the cart drawer instead of adding again (the cart page where there is no drawer).
   - Back and Forward from the history cache (finding N1): the cart bubble is set from cart.js, since Horizon only
     corrects it within 10 seconds of the last change. */
(function () {
  if (window.__noornsInCart) return;
  window.__noornsInCart = true;
  var me = document.currentScript;
  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var LABEL = 'In your cart';
  var ids = {};
  ((me && me.getAttribute('data-cart-variants')) || '').split(',').forEach(function (x) { if (x) ids[x] = 1; });

  function formVariant(form) {
    var i = form && form.querySelector && form.querySelector('input[name="id"]');
    return i ? String(i.value) : null;
  }
  function isAddForm(form) {
    var act = form.getAttribute('action') || '';
    return /\/cart\/add/.test(act) && formVariant(form);
  }
  function buttonsFor(form) {
    var out = [].slice.call(form.querySelectorAll('button[type="submit"]'));
    /* getAttribute, since form.id is the form's own input named "id" */
    var fid = form.getAttribute('id');
    if (fid) out = out.concat([].slice.call(document.querySelectorAll('button[type="submit"][form="' + fid + '"]')));
    return out;
  }
  function mark(btn, inCart) {
    if (!btn.hasAttribute('data-label')) btn.setAttribute('data-label', btn.textContent.trim());
    var was = btn.hasAttribute('data-in-cart');
    if (inCart && !was) {
      btn.setAttribute('data-in-cart', '');
      btn.textContent = LABEL;
      if (btn.hasAttribute('aria-label')) { btn.setAttribute('data-aria', btn.getAttribute('aria-label')); btn.setAttribute('aria-label', LABEL); }
    } else if (!inCart && was) {
      btn.removeAttribute('data-in-cart');
      btn.textContent = btn.getAttribute('data-label');
      if (btn.hasAttribute('data-aria')) btn.setAttribute('aria-label', btn.getAttribute('data-aria'));
    }
  }
  function paint() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (f) {
      var v = formVariant(f);
      if (!v) return;
      buttonsFor(f).forEach(function (b) { if (!b.disabled || b.hasAttribute('data-in-cart')) mark(b, !!ids[v]); });
    });
    document.querySelectorAll('[data-noorns-xsell]').forEach(function (b) { mark(b, !!ids[b.getAttribute('data-noorns-xsell')]); });
  }
  function setFromCart(cart) {
    ids = {};
    (cart.items || []).forEach(function (it) { ids[String(it.variant_id)] = 1; });
    paint();
  }
  var pending = null;
  function refresh() {
    if (pending) return pending;
    pending = fetch(base + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setFromCart(cart); return cart; })
      .catch(function () { return null; })
      .finally(function () { pending = null; });
    return pending;
  }
  function showCart() {
    var d = document.getElementById('cart-drawer');
    if (d && typeof d.open === 'function' && document.querySelector('cart-drawer-component')) {
      if (!d.isOpen) d.open();
      d.removeAttribute('data-just-added');
    } else {
      window.location.href = base + 'cart';
    }
  }

  /* capture phase, so this runs before the page's own add to cart handler and can stop it */
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    if (!(f instanceof HTMLFormElement) || !isAddForm(f)) return;
    var v = formVariant(f);
    if (ids[v]) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
      /* check the cart first: if the line was removed somewhere we didn't hear about, add it after all */
      refresh().then(function (cart) {
        if (!cart || ids[v]) { showCart(); return; }
        if (typeof f.requestSubmit === 'function') f.requestSubmit(); else showCart();
      });
      return;
    }
    ids[v] = 1; /* until cart.js says otherwise: stops a fast second press adding again */
    setTimeout(paint, 0);
  }, true);
  document.addEventListener('click', function (ev) {
    var b = ev.target.closest && ev.target.closest('[data-noorns-xsell]');
    if (!b) return;
    var v = b.getAttribute('data-noorns-xsell');
    if (ids[v]) { ev.preventDefault(); ev.stopImmediatePropagation(); showCart(); return; }
  }, true);

  /* after any cart change (adds, removes), read the cart once the change has settled. The event name is the one
     @shopify/events gives StandardEvents.cartLinesUpdate; it is listened for by name because a dynamic import
     from this classic script did not attach. */
  document.addEventListener('shopify:cart:lines-update', function (ev) {
    var done = function () { setTimeout(refresh, 50); };
    if (ev.promise && ev.promise.then) ev.promise.then(done, done); else setTimeout(refresh, 1200);
  });
  var drawerEl = document.getElementById('cart-drawer');
  if (drawerEl) drawerEl.addEventListener('close', function () { refresh(); }, true);

  window.addEventListener('pageshow', function (ev) {
    if (!ev.persisted) return;
    refresh().then(function (cart) {
      if (!cart) return;
      var icon = document.querySelector('cart-icon');
      if (icon && typeof icon.renderCartBubble === 'function') icon.renderCartBubble(cart.item_count, false);
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint); else paint();
  window.NoornsInCart = { refresh: refresh, has: function (v) { return !!ids[String(v)]; } };
})();
